import type { CreateContainerInput, HorizonRuleSnapshot } from '../domain/model';

const shiftDate = (days: number): string => {
  const date = new Date();
  date.setHours(12, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
};

export interface DemoContainer {
  input: CreateContainerInput;
  incident: boolean;
  partialRemaining: number | null;
}

export const createDemoContainers = (
  locationIds: string[],
  rules: HorizonRuleSnapshot[],
): DemoContainer[] => {
  const rule30 = rules.find((rule) => rule.durationDays === 30) ?? null;
  const rule90 = rules.find((rule) => rule.durationDays === 90) ?? null;
  const rule180 = rules.find((rule) => rule.durationDays === 180) ?? null;
  const firstLocation = locationIds[0] ?? '';
  const secondLocation = locationIds[1] ?? firstLocation;
  const thirdLocation = locationIds[2] ?? firstLocation;

  return [
    {
      input: {
        name: 'Bœuf bourguignon',
        categoryId: 'prepared',
        locationId: firstLocation,
        quantity: 750,
        unit: 'g',
        storageStartedOn: shiftDate(-78),
        manufacturerDateType: 'none',
        manufacturerDate: null,
        horizonRule: rule90,
        qualityHorizonOn: null,
        notes: 'Donnée fictive de démonstration',
      },
      incident: false,
      partialRemaining: null,
    },
    {
      input: {
        name: 'Haricots verts du jardin',
        categoryId: 'vegetables',
        locationId: secondLocation,
        quantity: 4,
        unit: 'portion',
        storageStartedOn: shiftDate(-165),
        manufacturerDateType: 'none',
        manufacturerDate: null,
        horizonRule: rule180,
        qualityHorizonOn: null,
        notes: 'Donnée fictive de démonstration',
      },
      incident: false,
      partialRemaining: 3,
    },
    {
      input: {
        name: 'Filets de poisson',
        categoryId: 'fish',
        locationId: thirdLocation,
        quantity: 2,
        unit: 'piece',
        storageStartedOn: shiftDate(-25),
        manufacturerDateType: 'DDM',
        manufacturerDate: shiftDate(120),
        horizonRule: rule30,
        qualityHorizonOn: null,
        notes: 'Vérifier les instructions de l’emballage',
      },
      incident: false,
      partialRemaining: null,
    },
    {
      input: {
        name: 'Soupe de courge',
        categoryId: 'prepared',
        locationId: firstLocation,
        quantity: 1,
        unit: 'contenant',
        storageStartedOn: shiftDate(-12),
        manufacturerDateType: 'none',
        manufacturerDate: null,
        horizonRule: rule90,
        qualityHorizonOn: null,
        notes: 'Donnée fictive de démonstration',
      },
      incident: true,
      partialRemaining: null,
    },
    {
      input: {
        name: 'Fraises',
        categoryId: 'fruit',
        locationId: secondLocation,
        quantity: 500,
        unit: 'g',
        storageStartedOn: shiftDate(-40),
        manufacturerDateType: 'none',
        manufacturerDate: null,
        horizonRule: rule90,
        qualityHorizonOn: null,
        notes: 'Donnée fictive de démonstration',
      },
      incident: false,
      partialRemaining: null,
    },
  ];
};
